export default "__VITE_ASSET__dImu8lxo__"